(() => {
  const searchDialog = document.getElementById('search-dialog');
  let searchTrigger = null;

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-open-search]');
    if (opener && searchDialog) {
      searchTrigger = opener;
      searchDialog.showModal();
      searchDialog.querySelector('input[type="search"]')?.focus();
      return;
    }
    if (event.target.closest('[data-close-dialog]')) {
      event.target.closest('dialog')?.close();
      return;
    }
    if (event.target === searchDialog) searchDialog.close();
    document.querySelectorAll('[data-mobile-menu][open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });
  searchDialog?.addEventListener('close', () => searchTrigger?.focus());

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-mobile-menu][open]').forEach((menu) => {
      menu.removeAttribute('open');
      menu.querySelector('summary')?.focus();
    });
  });

  document.addEventListener('submit', (event) => {
    if (!event.target.matches('[data-collection-form]')) return;
    event.target.querySelectorAll('input, select').forEach((field) => {
      if (field.name && field.value === '' && field.type !== 'checkbox') field.disabled = true;
    });
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-auto-submit]')) event.target.form?.requestSubmit();
  });

  function initGallery(gallery) {
    const track = gallery.querySelector('[data-gallery-track]');
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const counter = gallery.querySelector('[data-gallery-current]');
    if (!track) return;
    const slides = [...track.querySelectorAll('[data-media-id]')];
    const setCurrent = (index) => {
      thumbs.forEach((thumb, position) => {
        if (position === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = String(index + 1);
    };
    const show = (mediaId) => {
      const index = slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
      if (index < 0) return;
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      setCurrent(index);
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => show(thumb.dataset.galleryThumb)));
    let frame = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        setCurrent(Math.min(index, slides.length - 1));
      });
    }, { passive: true });
    gallery.showMedia = show;
  }

  function initProduct(root) {
    const dataScript = root.querySelector('[data-variants]');
    const picker = root.querySelector('[data-variant-picker]');
    const select = root.querySelector('[data-variant-select]');
    if (!dataScript || !picker || !select) return;
    const variants = JSON.parse(dataScript.textContent);
    const fieldsets = [...picker.querySelectorAll('fieldset[data-option-index]')];
    const button = root.querySelector('[data-add-button]');
    const label = root.querySelector('[data-add-label]');
    const status = root.querySelector('[data-variant-status]');
    const priceWrapper = root.querySelector('[data-price-wrapper]');
    const priceEl = priceWrapper?.querySelector('[data-price]');
    const compareEl = priceWrapper?.querySelector('[data-compare]');
    const compareAmount = priceWrapper?.querySelector('[data-compare-amount]');
    const showCompare = priceWrapper?.dataset.showCompare === 'true';
    const gallery = root.querySelector('[data-gallery]');
    const current = variants.find((variant) => String(variant.id) === select.value) || variants[0];
    const chosen = [...current.options];

    picker.hidden = false;
    root.querySelector('[data-variant-native]').hidden = true;

    const matches = (variant, index, value) => variant.options.every((option, position) => {
      if (position === index) return option === value;
      const fieldset = fieldsets.find((item) => Number(item.dataset.optionIndex) === position);
      return !fieldset || option === chosen[position];
    });

    const render = () => {
      fieldsets.forEach((fieldset) => {
        const index = Number(fieldset.dataset.optionIndex);
        fieldset.querySelectorAll('.option__value').forEach((item) => {
          const input = item.querySelector('input');
          const available = variants.some((variant) => variant.available && matches(variant, index, input.value));
          item.toggleAttribute('data-unavailable', !available);
          const hint = item.querySelector('[data-unavailable-text]');
          if (hint) hint.textContent = available ? '' : ', esaurita';
          if (input.checked) {
            const selected = fieldset.querySelector('[data-option-selected]');
            if (selected) selected.textContent = `: ${item.textContent.replace(', esaurita', '').trim()}`;
          }
        });
      });

      const variant = variants.find((item) => item.options.every((option, index) => option === chosen[index]));
      if (!variant) {
        button.disabled = true;
        label.textContent = 'Combinazione non disponibile';
        status.textContent = 'Questa combinazione non esiste. Scegli un’altra opzione.';
        return;
      }
      select.value = String(variant.id);
      const priced = variant.priceCents > 0;
      const buyable = variant.available && priced;
      button.disabled = !buyable;
      label.textContent = !priced ? 'Prezzo da verificare' : variant.available ? 'Aggiungi al carrello' : 'Esaurito';
      status.textContent = !priced ? 'Contatta il negozio per il prezzo.' : variant.available ? '' : 'Questa taglia è esaurita. Scegline un’altra o scrivici.';
      if (priceEl) priceEl.textContent = priced ? variant.price : 'Prezzo da verificare';
      if (compareEl) {
        const hasCompare = showCompare && variant.compareCents > variant.priceCents;
        compareEl.hidden = !hasCompare;
        if (hasCompare && compareAmount) compareAmount.textContent = variant.compare;
      }
      if (variant.media && gallery?.showMedia) gallery.showMedia(variant.media);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    picker.addEventListener('change', (event) => {
      const fieldset = event.target.closest('fieldset[data-option-index]');
      if (!fieldset) return;
      chosen[Number(fieldset.dataset.optionIndex)] = event.target.value;
      render();
    });
    render();
  }

  function initWithdrawal(form) {
    const next = form.querySelector('[data-withdrawal-next]');
    const back = form.querySelector('[data-withdrawal-back]');
    const stepOne = form.querySelector('[data-withdrawal-step="1"]');
    const stepTwo = form.querySelector('[data-withdrawal-step="2"]');
    const summary = form.querySelector('[data-withdrawal-summary]');
    if (!next || !stepTwo) {
      form.querySelector('[data-withdrawal-done]')?.focus();
      return;
    }
    next.hidden = false;
    back.hidden = false;
    stepTwo.hidden = true;
    next.addEventListener('click', () => {
      const fields = [...stepOne.querySelectorAll('input, textarea')];
      const invalid = fields.find((field) => !field.checkValidity());
      if (invalid) {
        invalid.reportValidity();
        return;
      }
      summary.replaceChildren(...fields.filter((field) => field.value).flatMap((field) => {
        const term = document.createElement('dt');
        term.textContent = form.querySelector(`label[for="${field.id}"]`)?.firstChild.textContent.trim() || field.name;
        const value = document.createElement('dd');
        value.textContent = field.type === 'date' && field.value ? field.value.split('-').reverse().join('/') : field.value;
        return [term, value];
      }));
      summary.hidden = false;
      stepOne.hidden = true;
      stepTwo.hidden = false;
      stepTwo.setAttribute('tabindex', '-1');
      stepTwo.focus();
    });
    form.addEventListener('submit', (event) => {
      if (stepTwo.hidden) {
        event.preventDefault();
        next.click();
      }
    });
    back.addEventListener('click', () => {
      stepTwo.hidden = true;
      stepOne.hidden = false;
      next.focus();
    });
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-product]').forEach(initProduct);
    scope.querySelectorAll('#WithdrawalForm').forEach(initWithdrawal);
  }

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
